module.exports = __webpack_public_path__ + "img/personify-a2z-events-logo.d982f507.svg";